import React, { useEffect, useState } from 'react';
import './PLC.css';

function PLC(props) {
   
var [PLC, setPLC] = useState([]);
var [htmlPLC, setHtmlPLC] = useState(<></>);
var idParque = (JSON.parse(sessionStorage.getItem("configuration"))[0].idSolarFarm);
const {code}=props;
const variablesAPedir="name,status,timeStamp";


let number = 0;
  useEffect(() => {
    fetch(window.location.protocol+"//"+window.location.hostname+"/api" + "/lastData/PLC?idSolarFarm="+idParque+"&variables="+variablesAPedir, { method: 'GET', credentials: 'include' })
      .then( async(dataPLC) => { setPLC(await dataPLC.json());})
      .catch(e => {console.log(e);})
      var interval1=setInterval(function () {
        number++;
        if(code == sessionStorage.getItem("key")) { // No ha cambiado de página
          fetch(window.location.protocol+"//"+window.location.hostname+"/api" + "/lastData/PLC?idSolarFarm="+idParque+"&variables="+variablesAPedir, { method: 'GET', credentials: 'include' })
          .then( async(dataPLC) => { setPLC(await dataPLC.json());})
          .catch(e => {console.log(e);})
        } else { // Ha cambiado de página. Cancela bucle
          clearInterval(interval1);
      }
    }, 30000)
  }, [number]);


  useEffect(()=>{
    htmlPLC = PLC.map((datoPLC, index) => {
    const {name,status,timeStamp } = datoPLC;
    if( (index+1) === PLC.length && PLC.length%3 !== 0){
        return(<>
            <div className='col'>  
                <div className="card tarjetas-plc">
                    <div className="card-body">
                        <h5 className="card-title">{name}</h5>
                        <label className="card-text"><strong>Estado: </strong>{status}</label><br/>
                        <label className="card-text"><strong>Último dato recibido:<br/></strong>{timeStamp} </label>
                    </div>
                </div>  
            </div> <div id="ultima-col" className='col'></div>
            </>);
        
    }else{
        return(<> 
            <div className='col'>  
                <div className="card tarjetas-plc">
                    <div className="card-body">
                        <h5 className="card-title">{name}</h5>
                        <label className="card-text"><strong>Estado: </strong>{status} </label><br/>
                        <label className="card-text"><strong>Último dato recibido:<br/></strong>{timeStamp} </label>                       
                    </div>
                </div>  
            </div>  </>)
    }
});
    setHtmlPLC(htmlPLC);
  }, [PLC]);

  return (
    <div className='container-fluid'>
        <div className='row'>
           {htmlPLC}
        </div>
    </div>
  );
};

export default PLC;